import { api, asItems } from "@/lib/api";

let citiesPromise;
const localitiesPromises = new Map();

export function loadDiscoveryCities({ refresh = false } = {}) {
  if (refresh || !citiesPromise) {
    citiesPromise = api.get("/web/discovery/cities")
      .then(({ data }) => asItems(data))
      .catch((error) => {
        citiesPromise = undefined;
        throw error;
      });
  }
  return citiesPromise;
}

export function loadDiscoveryLocalities(citySlug, { refresh = false } = {}) {
  if (refresh || !localitiesPromises.has(citySlug)) {
    const request = api.get(`/web/discovery/cities/${encodeURIComponent(citySlug)}/localities`)
      .then(({ data }) => asItems(data))
      .catch((error) => {
        localitiesPromises.delete(citySlug);
        throw error;
      });
    localitiesPromises.set(citySlug, request);
  }
  return localitiesPromises.get(citySlug);
}

export function clearDiscoveryCache() {
  citiesPromise = undefined;
  localitiesPromises.clear();
}
